import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/',
        component: () => import('@/components/Layout/Landing/Landing.vue'),
      },
      {
        path: '/programs',
        component: () => import('@/components/Layout/Programs/Program.vue'),
        meta: {
          apiBodyGetPayload: "searchApiBody/getPayload",
          apiBodyDefaultPayload: "searchApiBody/getDefaultPayload",
          apiBodySetPayload: "searchApiBody/updatePayload",
          tab: "Programs",
          tabText: "Program"
        }
      },
      {
        path: '/campaigns',
        component: () => import('@/components/Layout/Campaign/Campaigns.vue'),
        meta: {
          apiBodyGetPayload: "campaignApiBody/getPayload",
          apiBodyDefaultPayload: "campaignApiBody/getDefaultPayload",
          apiBodySetPayload: "campaignApiBody/updatePayload",
          tab: "Campaigns",
          tabText: "Ad"
        }
      },
      {
        path: '/site',
        component: () => import('@/components/Layout/Site/Site.vue'),
        meta: {
          apiBodyGetPayload: "siteApiBody/getPayload",
          apiBodyDefaultPayload: "siteApiBody/getDefaultPayload",
          apiBodySetPayload: "siteApiBody/updatePayload",
          tab: "Sites",
          tabText: "Site"
        }
      },
      {
        path: "/toplist",
        component: () => import("@/components/Layout/Toplist/Toplist")
      }
    ]
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import("@/views/Maintenance.vue"),
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.afterEach(() => {
  store.dispatch('checkCookieConsent');
});

export default router;
